import { render } from "preact";
import { App } from "./App";
import { bootstrapDesign, bootstrapTheme } from "./lib/theme";
import { bootstrapLayout } from "./lib/layout";
import { bootstrapSidebar } from "./lib/sidebarState";
import { probablyInTeams, tryTeamsSso } from "./lib/teamsContext";
import "./styles/index.css";

bootstrapTheme();
bootstrapDesign();
bootstrapLayout();
bootstrapSidebar();

const target = document.getElementById("app");
if (!target) {
  throw new Error("Missing #app mount node in index.html");
}

// Inside the Teams iframe: run SSO before mounting so the first /api/me call
// already carries a Bearer token. Outside Teams this falls through instantly.
async function boot(): Promise<void> {
  if (probablyInTeams()) {
    await tryTeamsSso();
  }
  render(<App />, target!);
}

void boot();
